import "./AccountPaymentHistory.scss";
import {useEffect, useState} from "react";



import moment from "moment";

import {useTranslation} from "react-i18next";
import useAppSelector from "../../../hooks/useAppSelector";
import {AccountService} from "../../../services/account.service";
import {IInvoice} from "../../../models/Invoice";
import Spinner from "../../../components/Spiner/Spinner";

const AccountPaymentHistory = () => {

    const {profile} = useAppSelector(state => state.profileSlice);
    const [paymentHistory, setPaymentHistory] = useState<{ loader: boolean, data: IInvoice[] }>({
        loader: true,
        data: []
    });
    const {gymSettings} = useAppSelector(state => state.gymSettingsSlice);
    const {t} = useTranslation();

    useEffect(() => {
        if (profile?.customerId) {
            getPaymentHistory(profile?.customerId);
        }
    }, [profile]);

    const getPaymentHistory = async (id: number) => {
        const response = await AccountService.getPaymentHistory(id);
        if (response.status === 200) {
            setPaymentHistory({loader: false, data: response.data});
        }
    }

    const getSubscriptionNameForInvoice = (invoice: IInvoice) => {
        let subscription = ""
        if (invoice.order && invoice.order.orderLines) {
            invoice.order.orderLines.forEach((o) => {
                if (o.package || o.packageOption) {
                    subscription += (o.package.name ? o.package.name : "") + ", ";
                } else {
                    if (subscription === "") subscription += "Drop in class  ";
                }
            });
        }
        if (subscription) {
            subscription = subscription.substring(0, subscription.length - 2);
        }
        return subscription;
    }

    if (paymentHistory.loader) {
        return (
            <div style={{paddingTop: "60px"}}>
                <Spinner/>
            </div>

        )
    }

    if (!paymentHistory.loader && !paymentHistory.data.length) {
        return (
            <section className="account-payment-history">
                <div className="container">
                    <div className="empty-box">
                        <h2 className="title">
                            {t("HaveNohistoryPayments")}
                        </h2>
                    </div>
                </div>
            </section>
        )
    }

    return (
        <div className="account-payment-history">
            <ul className="list">
                <li className="list-item list-item__main">
                    <ul className="row-list">
                        <li className="row-list__item">
                            {t("InvoiceNo")}
                        </li>
                        <li className="row-list__item">
                            {t("InvoiceType")}
                        </li>
                        <li className="row-list__item">
                            {t("Status")}
                        </li>
                        <li className="row-list__item">
                            {t("FullName")}
                        </li>
                        <li className="row-list__item">
                            {t("Subscription")}
                        </li>
                        <li className="row-list__item">
                            {t("Price")}
                        </li>
                        <li className="row-list__item">
                            {t("Date")}
                        </li>
                    </ul>
                </li>
                {
                    !paymentHistory.loader && paymentHistory.data.map(el => {
                        return (
                            <li key={el.id} className="list-item">
                                <ul className="row-list">
                                    <li className="row-list__item">
                                        <div className="content">
                                            <h4 className="title">{t("InvoiceNo")}</h4>
                                            <p className="info">{el.isCorporate ? gymSettings && gymSettings.invoicePrefix + el.corporateInvoiceNumber : gymSettings && gymSettings.invoicePrefix + el.invoiceNumber}</p>
                                        </div>
                                    </li>
                                    <li className="row-list__item">
                                        <div className="content">
                                            <h4 className="title">{t("InvoiceType")}</h4>
                                            <p className="info">{el.isCorporate ? "Corporate" : "Retail"}</p>
                                        </div>
                                    </li>
                                    <li className="row-list__item">
                                        <div className="content">
                                            <h4 className="title">{t("Status")}</h4>
                                            <span
                                                className={`status ${el.isCancelled ? "Canceled" : "Paid"}`}>{el.isCancelled ? "Canceled" : "Paid"}</span>
                                        </div>
                                    </li>
                                    <li className="row-list__item">
                                        <div className="content">
                                            <h4 className="title">{t("FullName")}</h4>
                                            <p className="info">{el.customer.profile.firstname} {el.customer.profile.lastname}</p>
                                        </div>
                                    </li>
                                    <li className="row-list__item">
                                        <div className="content">
                                            <h4 className="title">{t("Subscription")}</h4>
                                            <p className="info">{getSubscriptionNameForInvoice(el)}</p>
                                        </div>
                                    </li>
                                    <li className="row-list__item">
                                        <div className="content">
                                            <h4 className="title">{t("Price")}</h4>
                                            <p className="info">{gymSettings && gymSettings.defaultCurrencyCode + el.finalPrice}</p>
                                        </div>
                                    </li>
                                    <li className="row-list__item">
                                        <div className="content">
                                            <h4 className="title">{t("Date")}</h4>
                                            <p className="info">{moment(el.invoiceTime).format("DD.MM.YYYY")}</p>
                                        </div>
                                    </li>
                                </ul>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default AccountPaymentHistory;